<template>
  <div>
    <!-- Happening now -->
    <div>
      <HappeningNow mode="Live" :votingFirst="false" :Ismobile="true"></HappeningNow>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import HappeningNow from 'src/components/Blocks/HappeningNow';

  export default {
    name: 'MobileAppHappeningNow',
    components: {
      HappeningNow,
    },
    data() {
      return {};
    },
    computed: {
      ...mapState({
        eventId: (state) => state.app.eventId,
      }),
    },
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  @import '~@/styles/theme';

  @import 'node_modules/bootstrap/scss/_functions';
  @import 'node_modules/bootstrap/scss/_variables';
  @import 'node_modules/bootstrap/scss/mixins/_breakpoints';
</style>
